var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('messages.payment_success')))]),_c('v-row',{staticClass:"mt-2"},[_c('v-img',{attrs:{"contain":"","width":"100","height":"200","src":require("@/assets/happy.png")}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }